// // src/serviceWorkerRegistration.js
// export function register() {
//   if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//       navigator.serviceWorker
//         .register(`${process.env.PUBLIC_URL}/service-worker.js`)
//         .then((registration) => {
//           console.log('✅ Service Worker registered:', registration);
//         })
//         .catch((error) => {
//           console.error('❌ Service Worker registration failed:', error);
//         });
//     });
//   }
// }




// src/serviceWorkerRegistration.js

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/service-worker.js`)
        .then((registration) => {
          console.log('✅ Service Worker registered');

          registration.onupdatefound = () => {
            const worker = registration.installing;
            if (!worker) return;

            worker.onstatechange = () => {
              if (
                worker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                // Tell new SW to activate immediately
                worker.postMessage({ type: 'SKIP_WAITING' });

                // Reload page to load new files
                window.location.reload();
              }
            };
          };
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });
    });
  }
}
